import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { useLang } from "../i18n";

export const CallStrip = () => {
  const { t } = useLang();
  return (
    <section data-testid="call-strip" className="bg-terra text-sand py-12 md:py-16">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="flex flex-col md:flex-row md:items-center md:justify-between gap-8"
        >
          <div>
            <p className="text-sand/75 text-xs font-bold tracking-[0.35em] uppercase mb-3">{t("callStrip.label")}</p>
            <a
              href="tel:+38977425420"
              data-testid="call-strip-phone-link"
              className="font-serif text-5xl md:text-7xl tracking-tight leading-none hover:text-coal transition-colors duration-300"
            >
              +389 77 425 420
            </a>
          </div>
          <div className="flex items-center gap-4">
            <a
              href="tel:+38977425420"
              data-testid="call-strip-call-button"
              aria-label="Call"
              className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-sand text-coal flex items-center justify-center transition-transform duration-300 hover:scale-110"
            >
              <Phone className="w-6 h-6 md:w-7 md:h-7" strokeWidth={1.8} />
            </a>
            <a
              href="viber://chat?number=%2B38977425420"
              data-testid="call-strip-viber-button"
              aria-label="Viber"
              className="w-14 h-14 md:w-16 md:h-16 rounded-full flex items-center justify-center transition-transform duration-300 hover:scale-110"
              style={{ backgroundColor: "#7360F2" }}
            >
              <img src="https://cdn.simpleicons.org/viber/ffffff" alt="Viber" className="w-6 h-6 md:w-7 md:h-7" />
            </a>
            <a
              href="https://wa.me/38977425420"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="call-strip-whatsapp-button"
              aria-label="WhatsApp"
              className="w-14 h-14 md:w-16 md:h-16 rounded-full flex items-center justify-center transition-transform duration-300 hover:scale-110"
              style={{ backgroundColor: "#25D366" }}
            >
              <img src="https://cdn.simpleicons.org/whatsapp/0b1f13" alt="WhatsApp" className="w-6 h-6 md:w-7 md:h-7" />
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
